import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=27f46840&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=27f46840&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f46840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f46840')) {
      api.createRecord('27f46840', component.options)
    } else {
      api.reload('27f46840', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=27f46840&scoped=true", function () {
      api.rerender('27f46840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Footer.vue"
export default component.exports